import { Checkbox } from "@episerver/ui-framework";
import React from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { CCCheckbox } from "../../CCCheckbox";

const CheckBoxBooleanField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, readOnly } = props;
    
    return (
        <>
            <label data-oui-component="true" className="oui-label">
                {property.friendlyName}
            </label>
            <Controller
                name={`extendedProperties[${index}].value`}
                control={control}
                render={({ field: { onChange, value } }) => <>
                    <CCCheckbox
                        checked={value == null || value == undefined ? property.validationData.defaultValue : value}
                        onChange={() => onChange(!value)}
                        readOnly={readOnly}
                    >
                        {property.validationData.label}
                    </CCCheckbox>
                </>}
            />
        </>
    );
};

export default CheckBoxBooleanField;
